import * as action_types from "./constants";
import { ServiceLineListingType } from "./types";

export type crewYardState = {
  serviceLineListing: {
    data: ServiceLineListingType[] | null;
    loader: boolean;
  };
  serviceLineDetail: {
    data: ServiceLineListingType | null;
    loader: boolean;
  };
  serviceDetail: {
    data: ServiceLineListingType | null;
    loader: boolean;
  };
  serviceListing: {
    data: ServiceLineListingType[] | null;
    loader: boolean;
  };
  serviceFormData: {
    loader: boolean;
    data: {
      category: [] | null;
      materials: [] | null;
      equipments: [] | null;
      units: [] | null;
      takeoff: [] | null;
    };
  };
  frequencyType: {
    data: {
      frequency: string;
    };
  };
};

const initialState: crewYardState = {
  serviceLineListing: {
    data: null,
    loader: true,
  },
  serviceLineDetail: {
    data: null,
    loader: true,
  },
  serviceDetail: {
    data: null,
    loader: true,
  },
  serviceListing: {
    data: null,
    loader: true,
  },
  serviceFormData: {
    loader: true,
    data: {
      category: null,
      materials: null,
      equipments: null,
      units: null,
      takeoff: null,
    },
  },
  frequencyType: {
    data: {
      frequency: "",
    },
  },
};

type MyDataActionType =
  | {
      type: typeof action_types.GET_SERVICE_LINE_LISTING;
      data: {
        payload: ServiceLineListingType[];
        loading: boolean;
      };
    }
  | {
      type: typeof action_types.GET_SERVICE_LINE_DETAILS;
      data: {
        payload: ServiceLineListingType;
        loading: boolean;
      };
    }
  | {
      type: typeof action_types.GET_SERVICE_DETAILS;
      data: {
        payload: ServiceLineListingType;
        loading: boolean;
      };
    }
  | {
      type: typeof action_types.GET_SERVICE_LISTING;
      data: {
        payload: ServiceLineListingType[];
        loading: boolean;
      };
    }
  | {
      type: typeof action_types.SERVICE_FORM_DATA;
      data: {
        payload: {
          category: [];
          materials: [];
          equipments: [];
          units: [];
          takeoff: [];
        };
        loading: boolean;
      };
    }
  | {
      type: typeof action_types.GET_FREQUENCY_FOR_CHILD;
      data: {
        payload: {
          frequency: string;
        };
      };
    };

const myTeamReducer = (
  state = initialState,
  action: MyDataActionType
): crewYardState => {
  const { type, data } = action;
  switch (type) {
    case action_types.GET_SERVICE_LINE_LISTING:
      return {
        ...state,
        serviceLineListing: {
          loader: data?.loading || false,
          data: data?.payload,
        },
      };

    case action_types.GET_SERVICE_LINE_DETAILS:
      return {
        ...state,
        serviceLineDetail: {
          loader: data?.loading || false,
          data: data?.payload,
        },
      };

    case action_types.GET_SERVICE_DETAILS:
      return {
        ...state,
        serviceDetail: {
          loader: data?.loading || false,
          data: data?.payload,
        },
      };

    case action_types.GET_SERVICE_LISTING:
      return {
        ...state,
        serviceListing: {
          loader: data?.loading || false,
          data: data?.payload,
        },
      };

    case action_types.SERVICE_FORM_DATA:
      return {
        ...state,
        serviceFormData: {
          loader: data?.loading || false,
          data: data?.payload,
        },
      };

    case action_types.GET_FREQUENCY_FOR_CHILD:
      return {
        ...state,
        frequencyType: {
          data: data?.payload,
        },
      };

    default:
      return state;
  }
};

export default myTeamReducer;
